module.exports = __webpack_public_path__ + "media/images/active-e769d3dcf741c4f39aa30c0225f93e94.svg";